import type { Coords } from '@/types';

/**
 * Conversions et distances géographiques.
 * Pures, sans dépendance, testables.
 */

/** Conversion degrés → radians */
export function toRad(d: number): number {
  return (d * Math.PI) / 180;
}

/**
 * Distance haversine (à vol d'oiseau) entre 2 points sur la Terre, en km.
 * Approximation sphérique suffisante à l'échelle continentale.
 */
export function haversine(a: Coords, b: Coords): number {
  const R = 6371; // Rayon moyen de la Terre en km
  const dLat = toRad(b[0] - a[0]);
  const dLon = toRad(b[1] - a[1]);
  const lat1 = toRad(a[0]);
  const lat2 = toRad(b[0]);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLon / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
  return Math.round(2 * R * Math.asin(Math.sqrt(h)));
}

/** Borne une valeur entre min et max */
export function clamp(v: number, mn: number, mx: number): number {
  return Math.max(mn, Math.min(mx, v));
}
